import { withCustomSize } from './WithCustomSize';

export { IconParkProvider } from './IconParkProvider';

// Arrows
export const DownSmallIcon = withCustomSize('DownSmall');
export const UpSmallIcon = withCustomSize('UpSmall');
export const RightSmallIcon = withCustomSize('RightSmall');
export const LeftSmallIcon = withCustomSize('LeftSmall');
export const LeftSmallDownIcon = withCustomSize('LeftSmallDown');
export const LeftSmallUpIcon = withCustomSize('LeftSmallUp');
export const RightSmallDownIcon = withCustomSize('RightSmallDown');
export const RightSmallUpIcon = withCustomSize('RightSmallUp');
export const ArrowDownIcon = withCustomSize('ArrowDown');
export const ArrowUpIcon = withCustomSize('ArrowUp');
export const ArrowRightIcon = withCustomSize('ArrowRight');
export const ArrowLeftIcon = withCustomSize('ArrowLeft');
export const ArrowLeftDownIcon = withCustomSize('ArrowLeftDown');
export const ArrowLeftUpIcon = withCustomSize('ArrowLeftUp');
export const ArrowRightDownIcon = withCustomSize('ArrowRightDown');
export const ArrowRightUpIcon = withCustomSize('ArrowRightUp');
export const CircularConnectionIcon = withCustomSize('CircularConnection');
export const CornerUpRightIcon = withCustomSize('CornerUpRight');
export const CornerUpLeftIcon = withCustomSize('CornerUpLeft');
export const CornerRightUpIcon = withCustomSize('CornerRightUp');
export const CornerRightDownIcon = withCustomSize('CornerRightDown');
export const CornerLeftUpIcon = withCustomSize('CornerLeftUp');
export const CornerLeftDownIcon = withCustomSize('CornerLeftDown');
export const CornerDownRightIcon = withCustomSize('CornerDownRight');
export const CornerDownLeftIcon = withCustomSize('CornerDownLeft');
export const DownIcon = withCustomSize('Down');
export const UpIcon = withCustomSize('Up');
export const RightIcon = withCustomSize('Right');
export const LeftIcon = withCustomSize('Left');
export const DoubleDownIcon = withCustomSize('DoubleDown');
export const DoubleLeftIcon = withCustomSize('DoubleLeft');
export const DoubleRightIcon = withCustomSize('DoubleRight');
export const DoubleUpIcon = withCustomSize('DoubleUp');
export const RightOneIcon = withCustomSize('RightOne');
export const LeftOneIcon = withCustomSize('LeftOne');
export const DownOneIcon = withCustomSize('DownOne');
export const UpOneIcon = withCustomSize('UpOne');
export const FillIcon = withCustomSize('Fill');
export const GoEndIcon = withCustomSize('GoEnd');
export const GoStartIcon = withCustomSize('GoStart');
export const ToBottomOneIcon = withCustomSize('ToBottomOne');
export const ToTopOneIcon = withCustomSize('ToTopOne');
export const DownloadIcon = withCustomSize('Download');
export const UploadIcon = withCustomSize('Upload');
export const LoginIcon = withCustomSize('Login');
export const LogoutIcon = withCustomSize('Logout');
export const ShareIcon = withCustomSize('Share');
export const ShareThreeIcon = withCustomSize('ShareThree');
export const ExpandTextInputIcon = withCustomSize('ExpandTextInput');
export const CollapseTextInputIcon = withCustomSize('CollapseTextInput');
export const FullScreenIcon = withCustomSize('FullScreen');
export const FullScreenOneIcon = withCustomSize('FullScreenOne');
export const OffScreenOneIcon = withCustomSize('OffScreenOne');
export const OffScreenIcon = withCustomSize('OffScreen');
export const OffScreenTwoIcon = withCustomSize('OffScreenTwo');
export const FullScreenTwoIcon = withCustomSize('FullScreenTwo');
export const SortAmountDownIcon = withCustomSize('SortAmountDown');
export const SortAmountUpIcon = withCustomSize('SortAmountUp');
export const SortFourIcon = withCustomSize('SortFour');
export const SortThreeIcon = withCustomSize('SortThree');
export const SortTwoIcon = withCustomSize('SortTwo');
export const SwitchIcon = withCustomSize('Switch');
export const ClickToFoldIcon = withCustomSize('ClickToFold');
export const SortIcon = withCustomSize('Sort');
export const TransferDataIcon = withCustomSize('TransferData');
export const BackIcon = withCustomSize('Back');
export const ShareTwoIcon = withCustomSize('ShareTwo');
export const SlidingVerticalIcon = withCustomSize('SlidingVertical');
export const SlidingHorizontalIcon = withCustomSize('SlidingHorizontal');
export const TrendingUpIcon = withCustomSize('TrendingUp');
export const InvertLeftIcon = withCustomSize('InvertLeft');
export const BackOneIcon = withCustomSize('BackOne');
export const InvertRightIcon = withCustomSize('InvertRight');
export const GoAheadIcon = withCustomSize('GoAhead');
export const UndoIcon = withCustomSize('Undo');
export const RedoIcon = withCustomSize('Redo');
export const RotationHorizontalIcon = withCustomSize('RotationHorizontal');
export const RotationVerticalIcon = withCustomSize('RotationVertical');
export const RefreshIcon = withCustomSize('Refresh');
export const SpannerIcon = withCustomSize('Spanner');

// Add / Reduce / Comment
export const PlusIcon = withCustomSize('Plus');
export const MinusIcon = withCustomSize('Minus');
export const AddFourIcon = withCustomSize('AddFour');
export const AddIcon = withCustomSize('Add');
export const ReduceIcon = withCustomSize('Reduce');
export const CommentIcon = withCustomSize('Comment');
export const CommentOneIcon = withCustomSize('CommentOne');
export const MessageIcon = withCustomSize('Message');
export const MessageOneIcon = withCustomSize('MessageOne');
export const MessageSentIcon = withCustomSize('MessageSent');
export const FileAdditionOne = withCustomSize('FileAdditionOne');

// Blocks
export const DragIcon = withCustomSize('Drag');
export const ApplicationMenuIcon = withCustomSize('ApplicationMenu');
export const ActivitySourceIcon = withCustomSize('ActivitySource');
export const VerticalTidyUpIcon = withCustomSize('VerticalTidyUp');
export const SystemIcon = withCustomSize('System');
export const MemoryOneIcon = withCustomSize('MemoryOne');
export const AllApplicationIcon = withCustomSize('AllApplication');
export const MoreAppIcon = withCustomSize('MoreApp');
export const ApplicationTwoIcon = withCustomSize('ApplicationTwo');
export const ServerIcon = withCustomSize('Server');
export const AppSwitchIcon = withCustomSize('AppSwitch');

// Chart
export const ChartHistogramOneIcon = withCustomSize('ChartHistogramOne');
export const ChartHistogramIcon = withCustomSize('ChartHistogram');
export const ChartHistogramTwoIcon = withCustomSize('ChartHistogramTwo');
export const ChartLineAreaIcon = withCustomSize('ChartLineArea');
export const ChartLineIcon = withCustomSize('ChartLine');
export const ChartPieIcon = withCustomSize('ChartPie');
export const ChartProportionIcon = withCustomSize('ChartProportion');
export const PieThreeIcon = withCustomSize('PieThree');
export const PieTwoIcon = withCustomSize('PieTwo');
export const HistogramIcon = withCustomSize('Histogram');
export const RankingIcon = withCustomSize('Ranking');
export const ChartStockIcon = withCustomSize('ChartStock');
export const BubbleChartIcon = withCustomSize('BubbleChart');
export const ZoomInIcon = withCustomSize('ZoomIn');
export const ZoomOutIcon = withCustomSize('ZoomOut');
export const LocalPinIcon = withCustomSize('LocalPin');
export const LocalTwoIcon = withCustomSize('LocalTwo');
export const LocalIcon = withCustomSize('Local');
export const FiveFiveIcon = withCustomSize('FiveFive');
export const MoveInOneIcon = withCustomSize('MoveInOne');
export const AverageIcon = withCustomSize('Average');
export const ScatterAlignmentIcon = withCustomSize('ScatterAlignment');

// Edit
export const WriteIcon = withCustomSize('Write');
export const EditIcon = withCustomSize('Edit');
export const EditTwoIcon = withCustomSize('EditTwo');
export const DeleteIcon = withCustomSize('Delete');
export const DeleteOneIcon = withCustomSize('DeleteOne');
export const DeleteFourIcon = withCustomSize('DeleteFour');
export const CopyIcon = withCustomSize('Copy');
export const CopyOneIcon = withCustomSize('CopyOne');
export const LockIcon = withCustomSize('Lock');
export const UnlockIcon = withCustomSize('Unlock');
export const FolderOpenIcon = withCustomSize('FolderOpen');
export const PencilIcon = withCustomSize('Pencil');
export const ScreenshotOneIcon = withCustomSize('ScreenshotOne');

// Filter
export const LeftAlignmentIcon = withCustomSize('LeftAlignment');
export const CenterAlignmentIcon = withCustomSize('CenterAlignment');
export const FilterIcon = withCustomSize('Filter');
export const EqualizerIcon = withCustomSize('Equalizer');
export const TreeListIcon = withCustomSize('TreeList');

// Marks
export const CheckSmallIcon = withCustomSize('CheckSmall');
export const CloseSmallIcon = withCustomSize('CloseSmall');
export const CautionIcon = withCustomSize('Caution');
export const AttentionIcon = withCustomSize('Attention');
export const InfoIcon = withCustomSize('Info');
export const CheckOneIcon = withCustomSize('CheckOne');
export const CloseOneIcon = withCustomSize('CloseOne');
export const HelpIcon = withCustomSize('Help');

// Menu
export const HamburgerButtonIcon = withCustomSize('HamburgerButton');
export const MoreIcon = withCustomSize('More');
export const MoreOneIcon = withCustomSize('MoreOne');
export const MoreTwoIcon = withCustomSize('MoreTwo');
export const MoreThreeIcon = withCustomSize('MoreThree');

// Navigation
export const ShareOneIcon = withCustomSize('ShareOne');
export const homeIcon = withCustomSize('Home');
export const HomeTwoIcon = withCustomSize('HomeTwo');
export const SendIcon = withCustomSize('Send');

// Preview
export const PreviewOpenIcon = withCustomSize('PreviewOpen');
export const PreviewCloseOneIcon = withCustomSize('PreviewCloseOne');
export const PreviewCloseIcon = withCustomSize('PreviewClose');

// Settings
export const SettingTwoIcon = withCustomSize('SettingTwo');
export const SettingOneIcon = withCustomSize('SettingOne');
export const SettingIcon = withCustomSize('Setting');
export const SettingThreeIcon = withCustomSize('SettingThree');
export const SettingConfigIcon = withCustomSize('SettingConfig');

// Time
export const TableFileIcon = withCustomSize('TableFile');
export const CalendarDotIcon = withCustomSize('CalendarDot');
export const CalendarThreeIcon = withCustomSize('CalendarThree');
export const CalendarIcon = withCustomSize('Calendar');
export const TimeIcon = withCustomSize('Time');
export const StopwatchIcon = withCustomSize('Stopwatch');
export const HistoryIcon = withCustomSize('History');
export const AlarmClockIcon = withCustomSize('AlarmClock');

// User
export const UserIcon = withCustomSize('User');
export const AddUserIcon = withCustomSize('AddUser');
export const RightUserIcon = withCustomSize('RightUser');
export const WrongUserIcon = withCustomSize('WrongUser');
export const ReduceUserIcon = withCustomSize('ReduceUser');
export const PeopleIcon = withCustomSize('People');
export const PeoplePlusOneIcon = withCustomSize('PeoplePlusOne');
export const PeoplePlusIcon = withCustomSize('PeoplePlus');
export const PeopleMinusOneIcon = withCustomSize('PeopleMinusOne');
export const PeopleMinusIcon = withCustomSize('PeopleMinus');
export const PeopleDeleteOneIcon = withCustomSize('PeopleDeleteOne');
export const PeopleDeleteIcon = withCustomSize('PeopleDelete');
export const PeoplesIcon = withCustomSize('Peoples');
export const PeoplesTwoIcon = withCustomSize('PeoplesTwo');

// Operate
export const ContrastViewIcon = withCustomSize('ContrastView');

// Others
export const RemindDisableIcon = withCustomSize('RemindDisable');
export const RemindIcon = withCustomSize('Remind');
export const AlarmIcon = withCustomSize('Alarm');
export const ReportIcon = withCustomSize('Report');
export const LikeIcon = withCustomSize('Like');
export const TipsIcon = withCustomSize('Tips');
export const PlatteIcon = withCustomSize('Platte');
export const DetectionIcon = withCustomSize('Detection');
export const LinkIcon = withCustomSize('Link');
export const RocketOneIcon = withCustomSize('RocketOne');
export const RocketIcon = withCustomSize('Rocket');
export const SunIcon = withCustomSize('Sun');
export const SunOneIcon = withCustomSize('SunOne');
export const MoonIcon = withCustomSize('Moon');
export const PuzzleIcon = withCustomSize('Puzzle');
export const PowerIcon = withCustomSize('Power');
export const BroadcastIcon = withCustomSize('Broadcast');
export const ShareSysIcon = withCustomSize('ShareSys');
export const SignalOneIcon = withCustomSize('SignalOne');
export const SignalStrengthIcon = withCustomSize('SignalStrength');
export const AutoFocusIcon = withCustomSize('AutoFocus');
export const PennantIcon = withCustomSize('Pennant');
export const FlagIcon = withCustomSize('Flag');
export const TagOneIcon = withCustomSize('TagOne');
export const LabelIcon = withCustomSize('Label');
export const RssIcon = withCustomSize('Rss');
export const LinkOneIcon = withCustomSize('LinkOne');
export const LinkTwoIcon = withCustomSize('LinkTwo');
export const PaperclipIcon = withCustomSize('Paperclip');
export const LoadingFourIcon = withCustomSize('LoadingFour');
export const LoadingOneIcon = withCustomSize('LoadingOne');
export const LoadingIcon = withCustomSize('Loading');
export const PauseOneIcon = withCustomSize('PauseOne');
export const PauseIcon = withCustomSize('Pause');
export const PlayOneIcon = withCustomSize('PlayOne');
export const TerminalIcon = withCustomSize('Terminal');
export const InstructionIcon = withCustomSize('Instruction');
export const CodeIcon = withCustomSize('Code');
export const CodeOneIcon = withCustomSize('CodeOne');
export const DeleteKeyIcon = withCustomSize('DeleteKey');
export const DeleteTwoIcon = withCustomSize('DeleteTwo');
export const ShieldAddIcon = withCustomSize('ShieldAdd');
export const HarmIcon = withCustomSize('Harm');
export const ProtectIcon = withCustomSize('Protect');
export const SwitchButtonIcon = withCustomSize('SwitchButton');
export const LaptopComputerIcon = withCustomSize('LaptopComputer');
export const PrinterTwoIcon = withCustomSize('PrinterTwo');
export const PrinterIcon = withCustomSize('Printer');
export const PictureIcon = withCustomSize('Picture');
export const HandleRoundIcon = withCustomSize('HandleRound');
export const DataIcon = withCustomSize('Data');
export const LayersIcon = withCustomSize('Layers');
export const SmilingFaceIcon = withCustomSize('SmilingFace');
export const StarIcon = withCustomSize('Star');
export const ThumbsUpIcon = withCustomSize('ThumbsUp');
export const ThermometerIcon = withCustomSize('Thermometer');
export const RulerIcon = withCustomSize('Ruler');
export const AddOneIcon = withCustomSize('AddOne');
export const CloseIcon = withCustomSize('Close');
export const RotateIcon = withCustomSize('Rotate');

// Deprecated icon names
export const VerticalLinesIcon = withCustomSize('VerticalTidyUp');
export const PaletteIcon = withCustomSize('Platte');
export const PickerIcon = withCustomSize('Detection');
export const LineChartIcon = withCustomSize('ChartLine');
export const ExpandIcon = withCustomSize('ExpandTextInput');
export const CollapseIcon = withCustomSize('CollapseTextInput');
export const BarChartIcon = withCustomSize('ChartHistogramTwo');
export const ApplicationIcon = withCustomSize('AllApplication');
export const FiveIcon = withCustomSize('FiveFive');
export const MoveInIcon = withCustomSize('MoveInOne');

// Edit
export const AdjustmentIcon = withCustomSize('Adjustment');
